import ENDPOINTS from 'api/endpoints';
import { doDelete, doGet, doPatch, doPost } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import { generateNextPath } from 'lib/routeHelper';
import type {
  BaseSettingResponse,
  PatchSettingRequest,
  SettingsResponse,
  ViewRequest,
  ViewResponse,
} from './types';

export const getConversationsReviewSettings = (
  accountId: string,
  projectId: string,
) => {
  return doGet<SettingsResponse>(
    generateNextPath(ENDPOINTS.CONVERSATIONS_REVIEW_SETTINGS, {
      accountId,
      projectId,
    }),
    LOGGER_TYPE.JUPITER,
  );
};

export const patchConversationsReviewSetting = (
  accountId: string,
  projectId: string,
  body: PatchSettingRequest,
) => {
  return doPatch<BaseSettingResponse>(
    generateNextPath(ENDPOINTS.CONVERSATIONS_REVIEW_SETTINGS, {
      accountId,
      projectId,
    }),
    LOGGER_TYPE.JUPITER,
    body,
  );
};

export const getFilterViews = (accountId: string, projectId: string) => {
  return doGet<ViewResponse[]>(
    generateNextPath(ENDPOINTS.CONVERSATIONS_REVIEW_VIEWS, {
      accountId,
      projectId,
    }),
    LOGGER_TYPE.JUPITER,
  );
};

export const createFilterView = (
  accountId: string,
  projectId: string,
  body: ViewRequest,
) => {
  return doPost<ViewResponse>(
    generateNextPath(ENDPOINTS.CONVERSATIONS_REVIEW_VIEWS, {
      accountId,
      projectId,
    }),
    LOGGER_TYPE.JUPITER,
    body,
  );
};

export const updateFilterView = (
  accountId: string,
  projectId: string,
  viewId: string,
  body: ViewRequest,
) => {
  return doPatch<ViewResponse>(
    generateNextPath(ENDPOINTS.CONVERSATIONS_REVIEW_VIEW, {
      accountId,
      projectId,
      viewId,
    }),
    LOGGER_TYPE.JUPITER,
    body,
  );
};

export const deleteFilterView = (
  accountId: string,
  projectId: string,
  viewId: string,
) => {
  return doDelete<void>(
    generateNextPath(ENDPOINTS.CONVERSATIONS_REVIEW_VIEW, {
      accountId,
      projectId,
      viewId,
    }),
    LOGGER_TYPE.JUPITER,
  );
};
